<template>
  <div class="fixed_popup">
    <div class="row m-0 justify-content-center align-items-center h-100" @click.self="closeForgot">
      <div class="col-md-7 col-lg-6 col-sm-12 mt-3">
        <div @click="closeForgot" class="close_icon cursor">
          <ios-close-icon />
        </div>
        <form class="form_holder p-3" id="forgot-form" role="form" style="display: block;" @submit.prevent="onSubmit">
          <h3 class="text-center">Forgot Password</h3>
          <div class="row m-0 p-4">
            <div class="col-12 p-0">
              <div class="form-group">
                <input
                  type="email"
                  name="email"
                  id="email"
                  class="form-control"
                  placeholder="Email Address"
                  v-model="email"
                  required
                />
              </div>
              <div class="form-group mt-5">
              <div class="error_text text-center" v-if="hasError">{{errorMsg}}</div>
                <div class="text-center hoods_color pb-3" v-if="message">{{message}}</div>
                <button type="submit" class="btn btn-outline w-100">
                  Submit
                </button>
              </div>
              <!-- <div class="form-group">
                <button type="submit" class="btn btn-outline" style="width: 100%" :disabled="isLoading">
                  <i v-if="isLoading" class="fa fa-spinner fa-spin" />
                  Submit
                </button>
              </div> -->
              <div class="form-group">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="text-center smaller_font">
                      Back to <a @click="login" class="cursor">Login</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapActions
} from 'vuex'
import loadingMixin from '@/mixins/loading'

export default {
  data () {
    return {
      email: '',
      hasError: false,
      message: '',
      errorMsg: ''
    }
  },
  methods: {
    ...mapActions(['addMessage', 'clearMessage', 'resetPassword']),
    async onSubmit () {
      this.showLoading()
      let data = {
        email: this.email
      }
      this.resetPassword(data).then(() => {
        this.message = 'Please check your email to reset your password'
        this.hideLoading()
      }).catch((error) => {
        if (error) {
          this.hasError = true
          this.errorMsg = error.message
          this.hideLoading()
        }
      })
    },
    login () {
      this.$emit('goToLogin')
    },
    closeForgot () {
      this.$emit('closeForgot')
    }
  },
  mixins: [loadingMixin]
}
</script>
<style scoped>
.fixed_popup {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--dark-color-08);
}
.close_icon {
  position: absolute;
  right: 15px;
  top: 0;
  text-align: right;
  color: var(--dark-color);
}
.dark-mode .close_icon {
  color: var(--light-color);
}
.smaller_font {
  font-size: small;
}
</style>
